import { Expose } from "class-transformer";
import { ClientLineEnum } from "@altertec_gparn/lib";

export class UpdateClientDto {
  @Expose()
  id: string;

  @Expose()
  name: string;

  @Expose()
  vatNumber?: string;

  @Expose()
  sapCode?: string;

  @Expose()
  address?: string;

  @Expose()
  country?: string;

  @Expose()
  line?: ClientLineEnum;

  @Expose()
  bankId?: string;

  @Expose()
  clientGroupId: string;

  @Expose()
  clientPaymentMethodId?: string;

  @Expose()
  clientConditionCodeId?: string;

  @Expose()
  vatType?: number;

  @Expose()
  withholding?: number;
}
